import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BryCard, BryButton } from '../../../UI/BryUI';

const PassengerGuideCard = () => {
    const navigate = useNavigate();

    return (
        <BryCard 
            className="mb-4 border-0" 
            style={{ background: 'linear-gradient(135deg, var(--bry-accent) 0%, var(--bry-accent-dark, #088D91) 100%)', color: '#ffffff' }}
        >
            <h5 style={{ fontWeight: 700, marginBottom: '8px', fontSize: '18px', color: '#ffffff' }}>¿Cómo pedir servicios?</h5>
            <p style={{ fontSize: '13px', opacity: 0.95, marginBottom: '16px', lineHeight: '1.4', color: '#ffffff' }}>
                Es muy fácil: toca el botón de abajo, marca tu origen, destino y un conductor aceptará tu servicio en segundos.
            </p>
            <BryButton 
                variant="primary" 
                style={{ backgroundColor: '#ffffff', color: 'var(--bry-accent-dark, #088D91)', fontWeight: 800, border: 'none' }} 
                onClick={() => navigate('/solicitar-servicio')}
            >
                Comenzar ahora
            </BryButton>
        </BryCard>
    );
};

export default PassengerGuideCard;
